<div class="content-modal">
    <div class="modal-header">
        <h5 class="modal-title">Pauta de Evaluación de Validación</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <p class="modal-texto">La presente evaluación corresponde a un control de calidad de carácter confidencial, que no será visualizada por la dupla de validadores.</p>
    <form action="" [formGroup]="evaluacionFormGroup" (ngSubmit)="crearEvaluacionValidacion()">
    
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-3"><label for=""><strong>Código de Jardín Infantil:</strong></label></div>
                <div class="col-md-3"><input type="text" class="form-control" name="" placeholder={{this.jardineSelected.rbd}} disabled/></div>
                 <div class="col-md-1"><label for=""><strong>Yo:</strong></label></div>
                <div class="col-md-5"><input type="text" class="form-control" name="nombreDirectora"  formControlName="nombreDirectora"/></div>
     
            </div>
        </div>
    </div>



    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <p class="modal-texto-espe">Certifico que el procedimiento de Validación de la Autoevaluación, ha sido realizado bajo las siguientes características:
                </p>
            </div>
        </div>
    </div>
 
    <div class="row">

        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">1. La Reunión de validación fue ejecutada en la fecha previamente acordada. Si hubo cambio en la planificación, esto me fue informado y acordado con, al menos, 1 día de anticipación.
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta1" formControlName="respuesta1" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">2. La Reunión de validación fue iniciada a la hora previamente acordada. Si hubo algún cambio en la planificación, esto me fue informado antes del inicio de la reunión.
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta2" formControlName="respuesta2" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">3. La Reunión de validación fue realizada por dupla validadora externa designada por la Universidad de La Frontera. 
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta3" formControlName="respuesta3" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">4. La dupla validadora está conformada por profesionales del área de la educación, y al menos uno de ellos es Educadora de Párvulos, de acuerdo con lo acreditado en la carta de presentación disponible en plataforma. 
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta4" formControlName="respuesta4" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">5. La dupla validadora trabajó de forma simultánea permaneciendo conectados durante la realización de toda la reunión.
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta5" formControlName="respuesta5" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>


    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">6. La dupla validadora demostró competencias técnicas para este trabajo (conocimiento de conceptos e instrumentos).
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta6" formControlName="respuesta6" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">7. La dupla validadora fue receptiva ante nuestra exposición de medios de verificación.
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta7" formControlName="respuesta7" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">8. La dupla validadora mantuvo una actitud de diálogo y un comportamiento respetuoso con la comunidad educativa.
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta8" formControlName="respuesta8" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">9. La dupla validadora dio cumplimiento al procedimiento establecido (presentarse e indicar al inicio de la jornada los documentos que debo completar, sostener una reunión de inicio y al final de la jornada, acordar la distribución del trabajo y revisar los medios de verificación)
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta9" formControlName="respuesta9" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-10">
                    <p class="modal-texto-preguntas">10. La Reunión de validación se ejecutó en una o dos jornadas las que en su conjunto suman un mínimo de 6 y un máximo de 8 horas de duración.
                    </p>
                </div>
                <div class="col-md-2">
                    <mat-radio-group class="radio-group" name="respuesta10" formControlName="respuesta10" required>
                    <mat-radio-button value="1">si</mat-radio-button>
                    <mat-radio-button value="0">no</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>
    </div>

    <h5 class="modal-texto"><strong>OBSERVACIONES DIRECTORA/ENCARGADA:</strong></h5>

    <p class="modal-texto-espe">Registre aquí las observaciones o comentarios que considere relevantes en cuanto al cumplimiento de la labor de validación y su nivel de conformidad al respecto:</p>

    <div class="col-md-12">
        <div class="row">
            <textarea matInput class="form-control" placeholder="Escriba aquí sus observaciones..." name="observacion" formControlName="observacion"></textarea>
        </div>
    </div>

    <div class="col-md-12">
        <div class="row buttonFooter">
            <div class="col-md-12"><button type="button" class="buttonVolver" (click)="closeModal()">Volver</button>
                <button type="submit" *ngIf="buttonEnviarEvaluacion" class="buttonFirmar" [disabled]="!evaluacionFormGroup.valid">Enviar evaluación</button>
            </div>
        </div>
    </div>
</form>
</div>